// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2zoNJ","header":"ClearentDisclaimer_header__2YOzj","inner":"ClearentDisclaimer_inner__2NmPU"};